import React from 'react';
import classes from "./MethodList.module.css";

export default function MethodList({ first, second, three, secondList }) {
    const icon = <svg width="15" height="13" viewBox="0 0 15 13" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M2 6.46631C5.37871 6.46631 8.31586 6.46631 11.781 6.46631" stroke="#6231EB" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round" />
        <path d="M9.44849 2C9.95721 3.68691 11.5986 5.19171 13 6.25561C11.5122 7.33869 9.99561 9.13098 9.99561 11" stroke="#6231EB" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round" />
    </svg>;

    return (
        <div className={secondList ? `${classes.MethodList} ${classes.active}` : classes.MethodList}>
            <div className={classes.item}>
                <div className={classes.icon}>
                    {icon}
                </div>
                <div className={classes.description}>
                    <p dangerouslySetInnerHTML={{ __html: first }} />
                </div>
                {
                    secondList ?
                        <div className={classes.description_frame}>
                            <svg width="69" height="71" viewBox="0 0 69 71" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M20.3543 59.0938C31.5956 64.158 45.7433 57.0875 51.954 43.3013C58.1647 29.5151 54.0865 14.2339 42.8452 9.16962C31.6039 4.10538 17.4562 11.1759 11.2455 24.9621C5.0348 38.7483 9.11294 54.0295 20.3543 59.0938Z" stroke="#161616" strokeWidth="1.3" strokeLinecap="round" strokeLinejoin="round" />
                                <path d="M42.8452 9.16992L47.9472 11.4684C59.1896 16.5331 63.2669 31.8134 57.0582 45.595C50.8495 59.3767 36.7032 66.4472 25.4625 61.3832L20.3588 59.084" stroke="#161616" strokeWidth="1.3" strokeLinecap="round" strokeLinejoin="round" />
                                <path d="M31.043 22.1219L23.2926 27.156" stroke="#161616" strokeWidth="1.3" strokeLinecap="round" strokeLinejoin="round" />
                                <path d="M26.6362 20.6497L27.4173 31.0741" stroke="#161616" strokeWidth="1.3" strokeLinecap="round" strokeLinejoin="round" />
                                <path d="M45.1133 27.7063C42.181 30.3967 38.8745 32.4216 35.4688 33.6126" stroke="#161616" strokeWidth="1.3" strokeLinecap="round" strokeLinejoin="round" />
                                <path d="M39.7466 25.3599L40.5932 36.8247" stroke="#161616" strokeWidth="1.3" strokeLinecap="round" strokeLinejoin="round" />
                                <path d="M25.2749 36.6396C27.8416 39.257 31.0471 41.0884 34.6829 42.0148C32.5288 42.2067 30.3383 42.6577 28.1504 43.3597C25.9456 44.0691 23.8294 45.5104 22.1244 47.4638" stroke="#161616" strokeWidth="1.3" strokeLinecap="round" strokeLinejoin="round" />
                                <path d="M44.7673 13.8074C46.2565 14.6878 48.5065 17.6521 49.7557 20.8739C51.1023 24.3471 51.6876 28.1612 51.4156 30.2126" stroke="#161616" strokeWidth="1.3" strokeLinecap="round" />
                            </svg>
                        </div> :
                        ""
                }

            </div>
            <div className={classes.item}>
                <div className={classes.icon}>
                    {icon}
                </div>
                <div className={classes.description}>
                    <p dangerouslySetInnerHTML={{ __html: second }} />
                </div>
                {
                    !secondList ?
                        <div className={classes.description_shape_mobile}>
                            <svg width="149" height="124" viewBox="0 0 149 124" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M1 23.9831C20.5009 15.2117 41.1162 10.8244 62.1294 7.39858C83.9991 3.81996 107.181 1.82689 130.158 1.20286C145.511 0.7826 161.105 0.308203 174.05 7.67239C185.251 14.04 191.692 27.116 191.988 40.0041C192.284 52.8922 187.075 65.4556 179.444 75.8444C167.508 92.0819 149.834 103.502 130.976 110.583C112.119 117.664 91.9555 120.692 71.8878 122.577" stroke="#161616" strokeMiterlimit="10" strokeDasharray="9.55 9.55" />
                            </svg>
                        </div> :
                        ""
                }
            </div>
            <div className={classes.item}>
                <div className={classes.icon}>
                    {icon}
                </div>
                <div className={classes.description}>
                    <p dangerouslySetInnerHTML={{ __html: three }} />
                </div>
                {
                    secondList ?
                        <>
                            <div className={classes.description_shape}>
                                <svg width="451" height="148" viewBox="0 0 451 148" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M414.493 0.812794C441.883 11.3847 455.465 45.4875 448.218 73.9324C440.97 102.377 416.845 124.345 389.607 135.296C362.369 146.247 332.244 147.595 302.917 146.301C193.431 141.492 85.8243 100.905 0.390706 32.2718" stroke="#161616" strokeMiterlimit="10" strokeDasharray="19.82 19.82" />
                                </svg>
                            </div>
                            <div className={classes.description_mobile_frame}>
                                <svg width="188" height="93" viewBox="0 0 188 93" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M-0.0610623 1C-14.2173 2.02826 -25.3046 15.8843 -25.9625 30.0596C-26.6203 44.235 -18.5602 57.794 -7.508 66.6971C3.54425 75.6002 17.2853 80.4701 31.0296 84.0052C82.3374 97.2129 137.819 93.6108 187 73.9141" stroke="#161616" strokeMiterlimit="10" strokeDasharray="9.58 9.58" />
                                </svg>
                            </div>
                        </> :
                        ""
                }
            </div>
        </div>
    )
}
